import { type Event } from './types';
import { sendEvents } from '~shared/lib/analytics/src/sendEvents';
import { type ReduxDispatch } from '~shared/types';

export const EVENTS_GENERATED = 'EVENTS_GENERATED';

type EventsGenerated = {
  type: typeof EVENTS_GENERATED;
  payload: Event[];
};
export const eventsGenerated = (events: Event[]): EventsGenerated => {
  return {
    type: EVENTS_GENERATED,
    payload: events,
  };
};

export const EVENTS_FLUSHED_SUCCEEDED = 'EVENTS_FLUSHED_SUCCEEDED';

function eventsFlushedSucceeded(events: Event[]) {
  return {
    type: EVENTS_FLUSHED_SUCCEEDED,
    payload: {
      events,
    },
  };
}

export const EVENTS_FLUSHED_FAILED = 'EVENTS_FLUSHED_FAILED';

function eventsFlushedFailed() {
  return {
    type: EVENTS_FLUSHED_FAILED,
  };
}

export const EVENTS_FLUSH_STARTED = 'EVENTS_FLUSH_STARTED';

function eventsFlushStarted() {
  return {
    type: EVENTS_FLUSH_STARTED,
  };
}

export function flushAnalyticsEvents(events: Event[]) {
  return async (dispatch: ReduxDispatch) => {
    dispatch(eventsFlushStarted());

    // FIXME: CORS error for sending events to /onederlytics/record
    const json = await sendEvents(events);
    if (!json) return;
    if (json.error) {
      dispatch(eventsFlushedFailed());
    } else {
      dispatch(eventsFlushedSucceeded(events));
    }
  };
}

export const sendAnalyticsEvent = (event: Event) => (dispatch: ReduxDispatch) => {
  dispatch(eventsGenerated([event]));
};
